import {
  SET_FOODPROFILE,
  SET_FOODPROFILE_STATUS,
  SET_FM_TOKEN,
  TOGGLE_FOODPROFILE_BADGE,
  SHOW_MOBILE_SIDEBAR,
  HIDE_MOBILE_SIDEBAR,
  SET_FOODPROFILE_CONDITIONS,
  SET_PRODUCT_SUITABILITY,
} from '../actions/foodProfile';

/*
profile:
  undefined - not yet fetched from FM
  null - fetched from FM - not created, need to call authenticate API
  object - successfully fetched from FM
profileConditions:
  similar to profile
*/
export const initialState = {
  token: null,
  profileStatus: undefined,
  profile: undefined,
  profileConditions: undefined,
  productsSuitability: {},
  isBadgeEnabled: true,
  isMobileSidebarOpen: false,
};

export default function foodProfile(state = initialState, action) {
  switch (action.type) {
    case SET_FM_TOKEN: {
      return {
        ...state,
        token: action.data,
      };
    }
    case SET_FOODPROFILE: {
      return {
        ...state,
        profile: action.data,
      };
    }
    case SET_FOODPROFILE_STATUS: {
      return {
        ...state,
        profileStatus: action.data,
      };
    }
    case SET_FOODPROFILE_CONDITIONS: {
      return {
        ...state,
        profileConditions: action.data,
      };
    }
    case SHOW_MOBILE_SIDEBAR: {
      return {
        ...state,
        isMobileSidebarOpen: true,
      };
    }
    case HIDE_MOBILE_SIDEBAR: {
      return {
        ...state,
        isMobileSidebarOpen: false,
      };
    }
    case TOGGLE_FOODPROFILE_BADGE: {
      return {
        ...state,
        isBadgeEnabled: !state.isBadgeEnabled,
      };
    }
    case SET_PRODUCT_SUITABILITY: {
      return {
        ...state,
        productsSuitability: {
          ...state.productsSuitability,
          ...action.data,
        },
      };
    }
    default: {
      return state;
    }
  }
}
